import { version } from '@/../package.json'
import { type AppConfigType } from '@/types'

export const appConfig: AppConfigType = {
  version,
  env: import.meta.env.MODE,
  api: {
    url: import.meta.env.VITE_APP_EHR_API_URL || '/api',
    publicUrl: import.meta.env.VITE_APP_EHR_PUBLIC_API_URL || '/public',
  },
  auth0: {
    domain: import.meta.env.VITE_APP_AUTH0_DOMAIN || 'anzolo.us.auth0.com',
    clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID || '',
    audience: import.meta.env.VITE_APP_AUTH0_AUDIENCE || '',
  },
  sentry: {
    dns: import.meta.env.VITE_APP_SENTRY_DSN || '',
  },
  hotjar: {
    id: import.meta.env.VITE_APP_HOTJAR_ID,
  },
  links: {
    widgetForm: 'https://github.com/reprotoinc/js-widget-contact-form/blob/master/README.md',
    widgetCalendar:
      'https://github.com/reprotoinc/js-widget-calendar-form/blob/master/README.md#widget-installation-parameters',
  },
}
